import React from "react";
import { Button } from "@mui/material";
import ProgressBar from "./ProgressBar";
import { InfoButton } from "./Button";
import { useStore } from "../store/useStore";

const AppQuestionnaireLeftSide = ({
  data,
  assignappQuestionnaireId,
  hasApplicationInstructions,
  updating,
  dataQuestionnaire,
  handleInfoButton,
  handleFinishQuestionnaire,
  questionnaireContent,
  appState,
  progress,
  isQuestionnaireComplete,
  handleSaveQuestionnaire,
  questionnaireStatus,
  hasContextErrors,
  hasLoadErrors,
  isLoadingResponse,
}) => {
  const { applicacionData } = useStore();
  const isFinished = questionnaireStatus === "finished";

  const appName = applicacionData?.name || data?.application?.name || "Aplicación";
  const appDescription = data?.application?.description;

  const surveyInstructions = dataQuestionnaire?.survey?.[0]?.instructions;
  const questionnaireTitle = dataQuestionnaire?.survey?.[0]?.title;

  const ctx = dataQuestionnaire?.assignapp_questionnaire?.context || {};
  const nombreCurso = ctx?.nombre_curso;
  const objetivos = ctx?.objetivos;

  const headerTitle = nombreCurso ? `Cuestionario del curso ${nombreCurso}` : `Cuestionario ${questionnaireTitle}`;

  const decodeEscapedHtml = (str) => {
    return String(str)
      .replace(/\\u003c/g, "<")
      .replace(/\\u003e/g, ">")
      .replace(/\\u0022/g, '"')
      .replace(/\\u0027/g, "'")
      .replace(/\\n/g, "\n");
  };

  const escapeHtml = (s) =>
    String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");

  const textToHtmlWithBreaks = (text) => {
    const normalized = String(text).replace(/\r\n/g, "\n").replace(/\r/g, "\n");
    return escapeHtml(normalized).replace(/\n/g, "<br/>");
  };

  const hasObjetivos = typeof objetivos === "string" && objetivos.trim().length > 0;

  const instructionsToShow = assignappQuestionnaireId ? objetivos || surveyInstructions : appDescription;

  // Si hay objetivos, agrega subtítulo y formatea con saltos de línea
  const decodedHtml = instructionsToShow
    ? assignappQuestionnaireId && hasObjetivos
      ? `<h3 class="questionnaire-objectives-title">Objetivos del curso:</h3>${textToHtmlWithBreaks(objetivos)}`
      : decodeEscapedHtml(String(instructionsToShow))
    : "";

  const responsiveButtonSx = {
    fontSize: "var(--q-button-font-size)",
    px: "var(--q-button-px)",
    py: "var(--q-button-py)",
    minHeight: "var(--q-button-min-height)",
    lineHeight: 1.2,
    textTransform: "none",
    whiteSpace: "normal",
    textAlign: "center",
  };

  return (
    <div className={assignappQuestionnaireId ? "w-full py-5" : "application-overview"}>
      <div>
        {assignappQuestionnaireId ? (
          <h1 className="questionnaire-title">{headerTitle}</h1>
        ) : (
          <div className="application-overview__title-row">
            <h1>{appName}</h1>
            {hasApplicationInstructions && <InfoButton onClick={handleInfoButton} />}
          </div>
        )}
      </div>

      {!assignappQuestionnaireId && (
        <div className="application-overview__state">
          <span className="font-semibold">Estado:</span>

          <span className="bg-gray-200 py-1 px-3 rounded-full inline-block">{appState?.toUpperCase()}</span>
        </div>
      )}

      {!assignappQuestionnaireId && (
        <div className="application-overview__progress">
          <ProgressBar value={progress} />
        </div>
      )}

      <div className="questionnaire-instructions application-overview__description">
        <div dangerouslySetInnerHTML={{ __html: decodedHtml }} />
      </div>

      {assignappQuestionnaireId ? (
        <div className="questionnaire-content-wrapper">
          <div>{questionnaireContent}</div>

          <div className="mt-[14px]">
            {/* Botones */}
            <div className="questionnaire-actions">
              <Button
                variant="outlined"
                onClick={handleSaveQuestionnaire}
                disabled={updating || isFinished || !dataQuestionnaire?.survey?.[0]?.content || hasLoadErrors || isLoadingResponse}
                sx={responsiveButtonSx}
              >
                Guardar y regresar
              </Button>
            </div>

            {/* Mensajes informativos */}
            <div className="mt-2 space-y-1">
              {hasContextErrors && (
                <p className="questionnaire-message text-red-500">
                  No puede terminar el cuestionario porque hay errores en la configuración del contexto, contacte con el encargado.
                </p>
              )}

              {hasLoadErrors && !isLoadingResponse && (
                <p className="questionnaire-message text-red-500">
                  No puede terminar el cuestionario porque hubo un problema al cargar el cuestionario o sus respuestas. Recargue la página.
                </p>
              )}

              {!isFinished && !isQuestionnaireComplete && !hasLoadErrors && !isLoadingResponse && !!dataQuestionnaire?.survey?.[0]?.content && (
                <p className="questionnaire-message text-red-500">
                  Debe completar todas las preguntas obligatorias antes de terminar el cuestionario
                </p>
              )}

              {isFinished && <p className="text-gray-500 text-sm">Este cuestionario ya fue finalizado.</p>}
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default AppQuestionnaireLeftSide;
